// Сервер лежит / обновляется / нет сети — страница под роботом (Алексей 29.10 #3260: «посередине простой
// лоадер идёт, но было же про робота анимация»; #3274: «должна быть не плашка, а робот»). Текст — здесь
// же, под роботом; плашка сверху (ServerStatusBar) в это время молчит. Страница под экраном остаётся
// смонтированной: когда сервер ответил, робот улетает, а данные перезапрашиваются на месте
// (lib/serverHealth → mutate).
import { useEffect, useState } from 'react';
import { useT } from '@/contexts/I18nContext';
import { useServerHealth } from '@/lib/serverHealth';
import { progressOf, viewOf } from '@/components/common/ServerStatusNotice';
import { WaitingRobot } from '@/components/common/WaitingRobot';

/** Состояния, в которых страницу закрывает робот (плашка сверху в них не рисуется). */
export function robotCoversPage(kind: string): boolean {
  return kind === 'down' || kind === 'offline' || kind === 'back';
}

/** Выкатка: первые 30 с без ответа страницу не закрываем (Алексей 03.11 #3581 — «мы бы даже не
 *  начинали робота показывать»). С подменой API (ops/api_swap.sh) сервер не молчит дольше пары секунд,
 *  дашборд смены остаётся с последними данными и тихо перезапрашивает их. */
const DEPLOY_ROBOT_DELAY_MS = 30_000;

/** Короткий сбой («проверяем») не закрываем роботом — только если сервер правда не ответил. */
export function ServerDownOverlay() {
  const { t } = useT();
  const health = useServerHealth();
  const [now, setNow] = useState(() => Date.now());
  const [gone, setGone] = useState(true);
  const active = robotCoversPage(health.kind);
  const hold = health.kind === 'down' && viewOf(health, null, now) === 'updating'
    && now - health.since < DEPLOY_ROBOT_DELAY_MS;
  useEffect(() => {
    if ((health.kind === 'down' && !hold) || health.kind === 'offline') setGone(false);
  }, [health.kind, hold]);
  useEffect(() => {
    if (!active) return;
    const id = window.setInterval(() => setNow(Date.now()), 500);
    return () => window.clearInterval(id);
  }, [active]);
  if (gone) return null;
  const view = viewOf(health, null, now);
  const progress = health.kind === 'down' || health.kind === 'back' ? progressOf(health, now) : null;
  const updating = view === 'updating';
  const title = view === 'offline' ? t('serverStatus.offline.title')
    : updating ? t('serverStatus.updating.title')
    : view === 'back' ? t('serverStatus.back.title')
    : t('serverStatus.noResponse.title');
  const hint = view === 'offline' ? t('serverStatus.offline.hint')
    : updating ? t(progress != null && progress > 0.9 ? 'serverStatus.updating.slow' : 'serverStatus.updating.hint')
    : view === 'back' ? null
    : t('serverStatus.noResponse.hint');
  return (
    <div role="status" aria-live="polite"
      className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-background/95 px-4 text-center">
      <WaitingRobot height={110} leaving={health.kind === 'back' || health.kind === 'ok'} onGone={() => setGone(true)} className="max-w-md" />
      <div className="text-base font-semibold">{title}</div>
      {hint && <div className="max-w-sm text-sm text-muted-foreground">{hint}</div>}
      {progress != null && (updating || view === 'back') && (
        <div className="h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-muted">
          <div className="h-full rounded-full bg-primary transition-[width] duration-500 ease-linear" style={{ width: `${Math.round(progress * 100)}%` }} />
        </div>
      )}
      {/* Кнопки «Повторить» нет (Алексей 31.10 #3462): проверка и так идёт каждые несколько секунд,
          кнопка ни разу ничего не меняла. */}
    </div>
  );
}

export default ServerDownOverlay;
